import login from './login'
import common from './common'
import verify from './verify'
import utils from './utils'
import router from './router'
import company from './company'
import admin from './admin'
import application from './application'
import org from './org'
import device from './device'
import template from './template'
import message from './message'
import firmware from './firmware'
import log from './log'

const zh = {
    ...common,
    login: login,
    verify: verify,
    utils: utils,
    router: router,
    company: company,
    admin: admin,
    application: application,
    org: org,
    device: device,
    template: template,
    message: message,
    firmware: firmware,
    log: log
}
export default zh
